import { ConfigService } from 'ngx-envconfig';
import { NGXLogger } from 'ngx-logger';
import { Injectable, ElementRef, ViewChild } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subscription } from 'rxjs';
import { Orange } from 'app/shared/models/orange.model';
import { PaiementObj } from 'app/shared/models/paiementObj.model';
import { PaiementService } from 'app/views/paiement/paiement.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { MatSnackBar } from '@angular/material';
import { AutreService } from 'app/shared/services/autre.service';
import { ResultatPaiement } from 'app/shared/models/resultatPaiement.model';
import { Operateur } from '../../shared/models/operateur.model';
import { Message } from '../../shared/models/message.models';
import { Afpaynotif } from '../../shared/models/afpay.model';
// import { a } from '@angular/core/src/render3';


@Injectable({
  providedIn: 'root'
})
export class OrangeService {

 httpOptions = {
    headers: new HttpHeaders({ 'Access-Control-Allow-Origin':'*' ,'Content-Type': 'application/json' , 'Accept': 'application/json'})
};

  private clientUrl = this.configService.get('ip');
  private getToken = this.configService.get('ip2');
  private getTokenOrange = this.configService.get('ipOrange');

  public items: any[];
  interval: any;
  VerifPaiementOMSub: Subscription;

  PaiementOrangeSub: Subscription;

  compteur: any;
  seconde = this.configService.get('timerMTN');
  secondeFlooz = this.configService.get('timerFlooz');
  secondeOrange;

  resultatPaiement: ResultatPaiement;

  afpaynotif:Afpaynotif = new Afpaynotif();


  private getToken2 = 'http://localhost:9104/';

  private initialiseSession = 'https://ompay.orange.ci/e-commerce/init.php/';
  private redirectionVersOmpayUrl = 'https://ompay.orange.ci/e-commerce/';
  private OmpayUrl = 'https://ompay.orange.ci/e-commerce/payment.php';
  private om = 'https://kyrmannpay.com/omphp/processpayment.php';
  private ompay = 'https://kyrmannpay.com/omphp/processpayment1.php';

  constructor(
    private paiementService: PaiementService,
    private http: HttpClient,
    private logger: NGXLogger,
    private configService: ConfigService,
    private loader: AppLoaderService,
    private snack: MatSnackBar,
    private autreService: AutreService,
  ) { }


    /**
   * Fonction pour mettre à jour prestashop ainsi que creer l'achat sur kyrmannPay apres un paiement depuis ORANGE
   * @param orange
   */
  public curlOrangeMS(urlCrypter, orange: Orange): Observable<HttpResponse<any>> {
    return this.http.post(this.clientUrl + '/orangeci/ompay/ipn' , orange, {
    observe: 'response',
    responseType: 'text',
    headers: new HttpHeaders({'Access-Control-Allow-Origin' : '*'}),
    params: {curl: urlCrypter}

  });
  }

  public getTokenOmpay(orange: Orange): Observable<HttpResponse<any>> {
    return this.http.post(this.getTokenOrange + 'ompay/getompaytoken', orange, {
      observe: 'response',
      responseType: 'text',
    });

  };

  public getTokenOmpayTest(orange: Orange): Observable<HttpResponse<any>> {
    // return this.http.post(this.getToken2 + 'coresnedai/carrier/getdata', orange, { // localhost
      return this.http.post(this.getTokenOrange + 'ompay/getompaytoken', orange, {
      observe: 'response',
      responseType: 'text'
    });

  };

  /**
   * Fonction pour rediriger l'utilisateur avec des parametres
   * @param path
   * @param params
   * @param method
   */
  postForm(path, params, method) {

    method = method || 'post';


    // let url = 'https://ompay.orange.ci/e-commerce/payment.php';
    //       var iframe = document.createElement('iframe');
    //       iframe.setAttribute('src', url);
    //       iframe.setAttribute('height', '400');
    //       iframe.setAttribute('width', '500');
    //       document.body.appendChild(iframe);

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);
    form.setAttribute('target', 'myFrame');

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    console.log("formulaire de redirection  " + form);
    form.submit();
    console.log();
}


/**
 * Generer une sessionId
 */
  genererSessionId() {
    let sessionId = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
    return sessionId;
  }


  public  goToOrange(orange: Orange): Observable<HttpResponse<any>> {
      return this.http.post(this.om, orange, {
      observe: 'response',
      responseType: 'text'
    });
  };

  public  goToPayOrange(orange: Orange): Observable<HttpResponse<any>> {
    return this.http.post(this.ompay, orange, {
    observe: 'response',
    responseType: 'text',
    headers: new HttpHeaders({ 'Access-Control-Allow-Origin':'*' ,'Content-Type': 'application/json' , 'Accept': 'application/json'})
  });
};

effectuerPaiementORANGE(paiementObj: PaiementObj, num: string) {

  this.logger.debug('Objet entrants, paiementObj ', paiementObj, ' num ', num);

    this.PaiementOrangeSub = this.paiementService.paiementORANGE(paiementObj.user, paiementObj.pass, num, paiementObj.totalPaid, paiementObj.idpanier, paiementObj.afid,paiementObj.otp,paiementObj.operator,paiementObj.category,paiementObj.sessionid,paiementObj.offreid,paiementObj.infos)
    .subscribe(data => {

      this.logger.trace('INITIALISATION PAIEMENT', data);
      let statuscode = data.status;

      switch (statuscode) {
        case 200: {
          this.snack.open('Paiement en attente...', 'OK', { duration: 7000 });


          let tid = data.body.tid;
          let sessionid = data.body.sessionid;
          let responsecode = data.body.responsecode;
          let responsemessage = data.body.responsemessage;
          let token = data.body.token;


      this.afpaynotif.afpayTransactionId = tid;
      this.afpaynotif.amount = paiementObj.totalPaid;
      this.afpaynotif.msisdn = paiementObj.msisdn;
      this.afpaynotif.responseCode = responsecode;
      this.afpaynotif.responseMessage = responsemessage;
      this.afpaynotif.offrereference = paiementObj.offreid;


        if(sessionid == paiementObj.sessionid){
          // timeout
          // Temps d'attente avant le premier checking (5secondes)
          this.timerVerification(tid,token,sessionid,paiementObj.urlfeedback, paiementObj.curlParam, paiementObj.apiKey, paiementObj.idcustomer, paiementObj.idpanier, paiementObj.isprestashop,paiementObj.redirectType,this.afpaynotif);

          // Compteur pour arreter le checking
          this.doCompteur (Operateur.orange, paiementObj.urlfeedback, paiementObj.curlParam, paiementObj.isprestashop, paiementObj.idcustomer, paiementObj.idpanier,tid,paiementObj.redirectType,this.afpaynotif);

        } else {
          this.snack.open('Cette session est inconnue ou le paiement a échoué, vous serez redirigé vers le site du marchand !!', 'OK', { duration: 4000 });
          this.autreService.retourSiteMarchand(paiementObj.urlfeedback,this.resultatPaiement, paiementObj.idcustomer, paiementObj.idpanier,Operateur.orange,paiementObj.redirectType,this.afpaynotif);
        }

          break;
        }
        case 204: {
          this.loader.close();
          this.snack.open('No content', 'OK', { duration: 4000 });
          break;
        }
        case 500: {
          this.loader.close();
          this.snack.open('Erreur de paiement vous serez redirigé vers le site du marchand !', 'OK', { duration: 4000 });
          this.autreService.retourSiteMarchand(paiementObj.urlfeedback,this.resultatPaiement, paiementObj.idcustomer, paiementObj.idpanier,Operateur.orange,paiementObj.redirectType,this.afpaynotif);
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }
      }
    },
    error => {
      let statuscode = error.status;
      this.logger.error('Erreur', error.error, error);

      switch (statuscode) {
        case 404: {
          this.loader.close();
          this.snack.open('URL introuvable!', 'OK', { duration: 4000 });
          break;
        }
        case 500: {
          this.loader.close();
          this.snack.open('Internal server error!', 'OK', { duration: 4000 });
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }

      }

    } );
}


verifierPaiement(tid,token,sessionid, urlFeed: string, curl: string, apikey: string, idcustomer, idpanier, isPrestashop: boolean,redirectType:String,afpaynotif:Afpaynotif) {

  this.logger.trace('VERIF PAIEMENT', isPrestashop, curl);
  let ispresta = isPrestashop;
  this.VerifPaiementOMSub = this.paiementService.verifierPaiementOrange(tid,token,sessionid)
  .subscribe(data => {


    this.logger.trace('RESULTAT CHECK OBJ', data, isPrestashop);

    this.logger.trace('RESULTAT CHECK', data.body);
    let statuscode = data.status;

    switch (statuscode) {
      case 200: {

        let resultat =  JSON.parse(data.body);


        this.logger.trace('RESULTAT CHECK', resultat.achatfinalstatut);

        if (resultat.achatfinalstatut == "SUCCESS") {
          this.loader.close();
          this.snack.open('Paiement effectuer avec success, vous serez rediriger vers votre site d\'achat!', 'OK', { duration: 8000 });

          // Stopper le checking
          clearInterval(this.interval);
          clearInterval(this.compteur);

          // if (isPrestashop) {
          //   let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
            // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,tid,redirectType,resultat.achatfinalstatut);
            this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);

        //  } else {
        //    this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
        //  }

        } else if(resultat.achatfinalstatut == null) {
          console.log('Checking a nouveau');

        } else if(resultat.achatfinalstatut == Message.messageAttente) {
          console.log('Checking a nouveau');

        } else if(resultat.achatfinalstatut == Message.messageEchec) {

              clearInterval(this.interval);
              clearInterval(this.compteur);

              // if (isPrestashop) {
              //   let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
                // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,tid,redirectType,resultat.achatfinalstatut);
                this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
            // } else {
            //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
            // }
        } else {
            console.log('Checking a nouveau');
        }

        break;
      }
      case 206: {

        // this.resultatPaiement = JSON.parse(data.body);
        let resultat = JSON.parse(data.body);
        this.logger.trace('RESULTAT CHECK', data.body);

        if (resultat.achatfinalstatut == Message.messageReussite || resultat.achatfinalstatut == "success") {
          this.loader.close();
          this.snack.open('Paiement reussi, vous serez rediriger vers votre site d\'achat!', 'OK', { duration: 8000 });
          // Stopper le checking
          clearInterval(this.interval);
          clearInterval(this.compteur);


          // if (isPrestashop) {
          //    let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
            //  this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,tid,redirectType,resultat.achatfinalstatut);
            // this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange);
            this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);


          // } else {
          //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
          // }


        } else if(resultat.achatfinalstatut == Message.messageAttente || resultat.achatfinalstatut == "pending") {
          console.log('Checking a nouveau');

        } else if(resultat.achatfinalstatut == "FAILED" || resultat.achatfinalstatut == "failed") {

          clearInterval(this.interval);
          clearInterval(this.compteur);

              // if (isPrestashop) {
              //   let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
                // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,tid,redirectType,resultat.achatfinalstatut);
                this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);

            // } else {
            //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
            // }
        } else {
            console.log('Checking a nouveau');
        }

        break;
      }
      case 204: {
        this.loader.close();
        this.items = [];
        this.snack.open('No content', 'OK', { duration: 4000 })
        clearInterval(this.interval);
        clearInterval(this.compteur);
        this.resultatPaiement.achatbillmaptransid = tid;
        this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
        break;
      }
      case 404: {
        this.loader.close();
        this.snack.open('Internal server error!', 'OK', { duration: 4000 })
         // Stopper le checking
         clearInterval(this.interval);
         clearInterval(this.compteur);
         this.resultatPaiement.achatbillmaptransid = tid;
         this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
        break;
      }
      case 500: {
        this.loader.close();
        this.snack.open('Internal server error!', 'OK', { duration: 4000 })
         // Stopper le checking
         clearInterval(this.interval);
         clearInterval(this.compteur);
         this.resultatPaiement.achatbillmaptransid = tid;
         this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
        break;
      }
      default: {
        this.loader.close();
        this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })
         // Stopper le checking
         clearInterval(this.interval);
         clearInterval(this.compteur);
         this.resultatPaiement.achatbillmaptransid = tid;
         this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);

        break;
      }
    }
  },
  error => {
    let statuscode = error.status;

    this.logger.error('Erreur', error.error, error);
    this.logger.trace('Erreur 2', isPrestashop, urlFeed);




    switch (statuscode) {

      case 400: {
        this.resultatPaiement = JSON.parse(error.error);
        let resultat = JSON.parse(error.error);
        this.snack.open('Echec du paiement, un problème est servenu Contactez les administrateurs de la plateforme!', 'OK', { duration: 8000 });
        this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
        break;
      }
      case 402: {
        this.resultatPaiement = JSON.parse(error.error);
        let resultat = JSON.parse(error.error);
        this.logger.trace('RESULTAT', resultat);

        if (resultat.achatfinalstatut == Message.messageEchec || resultat.achatfinalstatut == Message.messageCreditInsuffisant) {
          this.loader.close();
          if (resultat.achatfinalstatut == Message.messageCreditInsuffisant) {
            this.logger.trace('CREDIT INSUFFISANT');
            this.snack.open('Credit insuffisant, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });
            this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
          } else {
            this.logger.trace('AUTRE ERREUR');
            this.snack.open('Echec du paiement, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });
            this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
          }
          // console.log('Stopper interval');
          // Stopper le checking
          clearInterval(this.interval);
          clearInterval(this.compteur);

          // if (isPrestashop) {
          //   let token = this.configService.get('mauvaisToken');
          //   this.logger.trace('isPrestashop', isPrestashop, token);
            // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,tid,redirectType,resultat.achatfinalstatut);
            this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
            // this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange);
          // } else {
          //   this.logger.trace('isPrestashop', isPrestashop);

          //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
          // }

        }
        break;
      }
      case 404: {
        this.loader.close();
        this.snack.open('URL introuvable!', 'OK', { duration: 4000 })
         // Stopper le checking
         clearInterval(this.interval);
         clearInterval(this.compteur);

        break;
      }
      case 417: {
        let resultat = JSON.parse(error.error);
        this.logger.trace('RESULTAT CHECK', error.error);

        if (resultat.achatfinalstatut == Message.messageEchec) {
          this.loader.close();
          this.snack.open('Echec du paiement, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });
          // Stopper le checking
          clearInterval(this.interval);
          clearInterval(this.compteur);

          // if (isPrestashop) {
          //   let token = this.configService.get('mauvaisToken');
            // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,tid,redirectType,resultat.achatfinalstatut);
            this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
            // this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange);
          // } else {
          //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
          // }

        }
        break;
      }
      case 500: {
        this.loader.close();
        this.snack.open('Internal server error!', 'OK', { duration: 4000 })
         // Stopper le checking
         clearInterval(this.interval);
         clearInterval(this.compteur);

        break;
      }
      default: {
        this.loader.close();
        this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })
         // Stopper le checking
         clearInterval(this.interval);
         clearInterval(this.compteur);

        break;
      }

    }

  } );
}


  /**
   * Fonction de verification de statut (Checking regulier de 5s)
   */
  timerVerification (tid,token,sessionid,urlFeed: string, curl: string, apikey: string, idcustomer, idpanier, isPrestashop: boolean,redirectType:String,afpaynotif:Afpaynotif) {
    setTimeout(() => {

      // console.log('timeout');
      // Verifier à interval regulier (5 secondes)
        this.interval = setInterval(() => {
          // Fonction de verification
          this.verifierPaiement(tid,token,sessionid,urlFeed,curl,apikey,idcustomer,idpanier,isPrestashop,redirectType,afpaynotif);
        }, 10000);

    }, 10000);
  }



  doCompteur (operateur: string, urlFeed: string, curl, isPrestashop, idcustomer, idcart,tid:String,redirectType:String,afpaynotif:Afpaynotif) {
    // Timer MOOV
    this.secondeFlooz = this.configService.get('timerFlooz');
      // Timer MTN
    this.seconde = this.configService.get('timerMTN');

    this.secondeOrange = this.configService.get('timerOrange');

    this.compteur = setInterval(() => {
      // console.log('compteur');
      // Fonction du compteur
      // this.seconde += 1;

      if (operateur == Operateur.mtn) {

      this.seconde-- ;
      // console.log(this.seconde);
      if (this.seconde == 0 ) {
        // console.log(this.seconde);
        // Stopper le checking
        clearInterval(this.compteur); // Compteur
        clearInterval(this.interval); // Status

        this.snack.open('Temps d\'attente dépassé, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

        // if (isPrestashop) {
        //   let token = this.configService.get('mauvaisToken');
          this.resultatPaiement.achatfinalstatut = 'FAILED';
          // this.autreService.curlUrlRetour(curl, token, Operateur.mtn, urlFeed,tid,redirectType, this.resultatPaiement.achatfinalstatut);
          // this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.orange);
          this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.orange,redirectType,afpaynotif);
        // } else {
        //   this.resultatPaiement.achatfinalstatut = 'FAILED'; // FAILED dû au timeout
        //   this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.orange,redirectType,afpaynotif);
        // }

      }

    } else if (operateur == Operateur.moov) {

      this.secondeFlooz-- ;
      if (this.secondeFlooz == 0 ) {
        // Stopper le checking
        clearInterval(this.compteur); // Compteur
        // Reinitialisé le compteur
      }

    }
    else if (operateur == Operateur.orange) {

      this.secondeOrange-- ;
      // console.log(this.seconde);
      if (this.secondeOrange == 0 ) {
        // console.log(this.seconde);
        // Stopper le checking
        clearInterval(this.compteur); // Compteur
        clearInterval(this.interval); // Status

        this.snack.open('Temps d\'attente dépassé, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

        // if (isPrestashop) {
        //   let token = this.configService.get('mauvaisToken');
          this.resultatPaiement.achatfinalstatut = 'FAILED';
          // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,tid,redirectType,this.resultatPaiement.achatfinalstatut );
          this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.orange,redirectType,afpaynotif);
          // this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.orange);
        // } else {
        //   this.resultatPaiement.achatfinalstatut = 'FAILED'; // FAILED dû au timeout
        //   this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.orange,redirectType,afpaynotif);
        // }

      }

    }


    }, 1000);

  }


}
